import React from 'react';
import {
  HomeOutlined as HomeIcon,
  InventoryOutlined as InventoryIcon,
  AssignmentOutlined as AssignmentIcon,
  ReceiptOutlined as ReceiptIcon,
  DescriptionOutlined as DescriptionIcon,
  SettingsOutlined as SettingsIcon,
  ComputerOutlined as ComputerIcon,
  ContactsOutlined as ContactsIcon,
} from '@mui/icons-material';

/** Iconos de módulos alineados con system-structure.ts y el wizard de roles. */
export const MODULE_ICONS: Record<string, React.ReactNode> = {
  home: <HomeIcon />,
  products: <InventoryIcon />,
  inventory: <AssignmentIcon />,
  orders: <ReceiptIcon />,
  crm: <ContactsIcon />,
  reports: <DescriptionIcon />,
  settings: <SettingsIcon />,
  system: <ComputerIcon />,
};

export const getModuleIcon = (moduleId: string): React.ReactNode =>
  MODULE_ICONS[moduleId] ?? <InventoryIcon />;
